const KEY = "dealer_login";
export const DEALER_RANGE_START = 10001001;
export const DEALER_RANGE_END = 10009999;
export const SESSION_HOURS = 12;

export function getDealerSession() {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;
        const s = JSON.parse(raw);
        if (s && s.kdn && s.exp > Date.now()) return s;
        localStorage.removeItem(KEY);
    } catch {
        /* ignore */
    }
    return null;
}

export function setDealerSession(kdn) {
    const s = { kdn: String(kdn), exp: Date.now() + SESSION_HOURS * 3600 * 1000 };
    try {
        localStorage.setItem(KEY, JSON.stringify(s));
    } catch {
        /* ignore */
    }
    return s;
}

export function formatEuro(cents) {
    return (cents / 100).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
}
